module.exports = __webpack_public_path__ + "0ee0b409d996386ef260d00a22c55e71.svg";